<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="VAT Sales Invoice List (Mushak 6.3)"
            />
        </div>

        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickGo"
            >
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 filter-label">
                    <label for="colFormLabel" class="col-form-label">Party</label>
                    <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                        <i class="fas fa-search"></i>
                    </span>
                    <AsyncSelect
                        placeholder="Select Party"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        :additional-query="additionalContactOption"
                        :format-label="formatPatientLabel"
                    />
                </div>
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2">
            <VatSalesListTable :sales-list="salesList"/>
        </div>

        <div class="px-2">
            <Pagination :offset="offset" @onPageChange="onPageChange"/>
        </div>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            type="customer"
        />
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue'
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import VatSalesListTable from '@/components/molecule/company/nbr/VatSalesListTable.vue'
import handlePurchase from '@/services/modules/purchase'
import handleContact from '@/services/modules/contact'
import { useAsyncDropdownHelper } from '@/services/utils/asyncDropdownHelper'

const route = useRoute()
const router = useRouter()
const store = useStore()

const { fetchSalesList } = handlePurchase()
const { fetchContactProfiles } = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper()

const offset = ref(20)
const salesList = ref([])
const contactProfile = ref(null)
const additionalContactOption = ref({
    with_mobile: 1,
    roles: 'customer'
})

const companyId = computed(() => {
    return route.params.companyId
})
const startDate = computed(() => {
    return route.query.start
})
const endDate = computed(() => {
    return route.query.end
})
const page = computed(() => {
    return route.query.page
})

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true
}

const onSearchContact = (contact) => {
    contactProfile.value = contact
}

const getQuery = () => {
    let query = '?company_id=' + companyId.value
    if (contactProfile.value) query += '&contact_profile_id=' + contactProfile.value.id
    if (startDate.value) query += '&start_date=' + startDate.value
    if (endDate.value) query += '&end_date=' + endDate.value
    if (page.value) query += '&page=' + page.value
    query += '&offset=' + offset.value
    return query
}

const setPagination = (data) => {
    if (!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onClickGo = async () => {
    const res = await fetchSalesList(getQuery())
    if (!res.status) {
        salesList.value = []
        store.commit('resetPagination')
        return
    }
    salesList.value = res.date.data
    setPagination(res.date)
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({ path: route.path, query: routeQuery })
    await onClickGo()
}

onMounted(() => {
    onClickGo()
})
</script>

<style scoped>
.filter-label {
    position: relative;
}
.filter-search-icon {
    position: absolute;
    right: 1.25rem;
    top: 0;
    font-size: 0.85rem;
    padding: calc(0.571rem + 1px) 0;
    line-height: 1.45;
}
</style>
